module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gc_sjcj.48035d8f.png";